// import dependencies
import * as bootstrap from 'bootstrap';
import "fontawesome-free-v6/js/all.min.js";
import "../scss/styles.builtbypurpose.scss";


// import vueJS dependencies
import { createApp } from 'vue';
import App from "../components/App.vue";
import router from "../routes/index.js";
import store from '../store/store';

export const eventBus = createApp(App)

createApp(App)
    .use(router)
    .use(store)
    .mount('#app');